{
  "blocks": [
    {
      "id": "med-levothyroxine",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "pre-cycle",
        "during-cycle",
        "thyroid",
        "evidence-based"
      ],
      "title": "Synthroid",
      "subtitle": "Levothyroxine - thyroid hormone replacement for hypothyroidism",
      "body": {
        "genericName": "Levothyroxine (T4)",
        "drugClass": "Thyroid hormone replacement",
        "purpose": "Replaces or supplements thyroid hormone in women with hypothyroidism or subclinical hypothyroidism. Thyroid status can affect ovulation, implantation, and early pregnancy. Most fertility clinics target a TSH below 2.5 mIU/L before conception and during the first trimester.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "25-200 mcg daily, starting low (25-50 mcg) and adjusting based on TSH levels every 4-6 weeks",
        "howToTake": "Step 1: Prepare - Set a consistent morning alarm. Keep your levothyroxine somewhere visible as a reminder to take it before eating or drinking anything other than water. | Step 2: Take medication - Take on an empty stomach first thing in the morning with a full glass of water. Swallow the tablet whole. | Step 3: After taking - Wait at least 30-60 minutes before eating, drinking coffee, or taking other medications. Take prenatal vitamins (especially those containing iron or calcium) at least 4 hours later, as they significantly interfere with absorption. Take at the same time every day for consistent thyroid hormone levels. | ⚠ Missed dose - Take the missed dose as soon as you remember, as long as it is not close to the time of your next dose. If it is almost time for your next dose, skip the missed dose. Do not double up. Consistent daily dosing is important for stable TSH levels during fertility treatment. | ⚠ When to call clinic - Call if you experience palpitations, a racing heart, unusual anxiety, jitteriness, or significant insomnia, as these may indicate your dose is too high and needs adjustment. Also contact your clinic if your TSH was rechecked and is outside the target range (below 2.5 mIU/L for fertility treatment).",
        "sideEffects": [
          "Usually well-tolerated at correct dose",
          "Palpitations or racing heart (if dose too high)",
          "Anxiety or jitteriness (if dose too high)",
          "Insomnia (if dose too high)",
          "Headache during initial adjustment",
          "Hair loss (temporary, during dose changes)",
          "Weight changes"
        ],
        "storage": "Store at room temperature (15-30°C / 59-86°F). Protect from moisture and light. Keep in original container.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Synthroid", "Levoxyl", "Tirosint", "Unithroid"]
          },
          {
            "country": "UK",
            "brands": ["Levothyroxine", "Eltroxin"]
          },
          {
            "country": "EU",
            "brands": ["Euthyrox", "Levothyrox", "Eltroxin"]
          },
          {
            "country": "AU",
            "brands": ["Oroxine", "Eutroxsig"]
          },
          {
            "country": "FR",
            "brands": ["Levothyrox", "Euthyrox", "L-Thyroxin Henning", "Tcaps"],
            "cisByBrand": {
              "Levothyrox": "65143010",
              "L-Thyroxin Henning": "62127264",
              "Tcaps": "69288373"
            }
          }
        ],
        "aliases": [
          "Levothyroxine",
          "Lévothyroxine",
          "Lévothyrox",
          "L-Thyroxine Henning",
          "L-Thyroxine",
          "T4"
        ],
        "forWhom": "her",
        "frBody": {
          "genericName": "Lévothyroxine (T4)",
          "drugClass": "Hormone thyroïdienne de substitution",
          "purpose": "Remplace ou complète l'hormone thyroïdienne chez les femmes atteintes d'hypothyroïdie ou d'hypothyroïdie infraclinique. Le statut thyroïdien peut influencer l'ovulation, l'implantation et le début de grossesse. La plupart des centres d'AMP visent une TSH inférieure à 2,5 mUI/L avant la conception et pendant le premier trimestre.",
          "dosageRanges": "25 à 200 µg par jour, débutée à dose faible (25-50 µg) puis ajustée selon les taux de TSH toutes les 4 à 6 semaines.",
          "howToTake": "Préparer - Programmez une alarme matinale régulière. Gardez votre lévothyroxine à un endroit visible pour vous rappeler de la prendre avant de manger ou de boire (eau autorisée). | Prendre le médicament - Prenez à jeun dès le matin avec un grand verre d'eau. Avalez le comprimé entier. | Après la prise - Attendez au moins 30 à 60 minutes avant de manger, de boire du café ou de prendre d'autres médicaments. Prenez les vitamines prénatales (surtout celles contenant du fer ou du calcium) au moins 4 heures plus tard, car elles diminuent fortement l'absorption. Prenez à la même heure chaque jour pour des taux thyroïdiens stables. | ⚠ Dose oubliée - Prenez la dose oubliée dès que vous y pensez, sauf si l'heure de la dose suivante est proche. Si la dose suivante approche, sautez la dose oubliée. Ne doublez jamais la dose. La régularité quotidienne est importante pour maintenir une TSH stable pendant l'AMP. | ⚠ Quand contacter le centre - Contactez votre centre en cas de palpitations, de tachycardie, d'anxiété inhabituelle, de nervosité ou d'insomnie marquée, qui peuvent évoquer une dose trop élevée nécessitant un ajustement. Contactez également votre centre si votre TSH recontrôlée est en dehors de la cible (inférieure à 2,5 mUI/L pour l'AMP).",
          "sideEffects": [
            "Généralement bien toléré à la bonne dose",
            "Palpitations ou tachycardie (si dose trop élevée)",
            "Anxiété ou nervosité (si dose trop élevée)",
            "Insomnie (si dose trop élevée)",
            "Maux de tête lors de l'ajustement initial",
            "Chute de cheveux (transitoire, lors des changements de dose)",
            "Variations de poids"
          ],
          "storage": "Conservez à température ambiante (15-30 °C). À protéger de l'humidité et de la lumière. Gardez dans l'emballage d'origine."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
